import { Button, Checkbox, Tabs } from 'antd';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import Icon from '../Icon/Icon';
import useContactDropdown from './useContactDropdown';
import { Conversation, MyContactRequest, ReceivedContactRequest } from './ContactDropdown.model';

import styles from './ContactDropdown.module.scss';
import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';

const ContactDropdown = ({ onClose }: any) => {
	const { TabPane } = Tabs;
	const { state, navigateTo, onPopupClose, toggleSection } = useContactDropdown();
	const { myRequests, network, pendingRequests, rejectedRequests, viewSection } = state;
	const { userId } = useAuthenticationDataContext();

	const tabBarExtraContent = {
		right: (<div className={styles.tabBarExtraContent}>
			<Button className={styles.btnWithIcon} type="default" size="large" onClick={toggleSection}>
				<Icon name="paper-plane" />
				<FormattedMessage id="contact.myRequests" />
			</Button>
			<Button onClick={onPopupClose.bind(null, onClose)} type="link" style={{ paddingRight: 0 }}>
				<Icon
					color="text"
					height="16px"
					name="times"
					width="16px"
				/>
			</Button>
		</div>)
	}

	const secondTabBarExtraContent = {
		left: <Button onClick={toggleSection} type="text"><Icon name="arrow-left" color="text" /></Button>,
		right: (<div className={styles.tabBarExtraContent}>
			<Button onClick={onClose} type="link" style={{ paddingRight: 0 }}>
				<Icon
					color="text"
					height="16px"
					name="times"
					width="16px"
				/>
			</Button>
		</div>)
	}

	const renderNetwork = () => {
		return network.map((item: Conversation, index: number) => {
			const { members, lastMessage } = item;
			const secondPerson = members.find(item => item.userId !== userId);
			return (
				<div className={styles.card} key={`network${index}`} onClick={!secondPerson?.isDeleted ? navigateTo.bind(null, `/members-list/${secondPerson?.userId}?tab=conversation`, onClose) : undefined}>
					<div className={styles.imageWrapper}>
						{secondPerson?.imageId && !secondPerson.isDeleted ?
							<img alt="Profile" src={secondPerson?.imageId} /> :
							<Icon name="user" width="16px" color="white" />}
					</div>
					<div>
						{!secondPerson?.isDeleted ? <span className={styles.clickable}>{secondPerson?.firstName} {secondPerson?.lastName}</span> :
							<span className={styles.clickable}>	<FormattedMessage id="userLabels.deletedUser" /></span>}
						<br />
						<span className={styles.contentMessage}>{lastMessage.content}</span>
						<span className={styles.messageDate}>{moment(lastMessage.sentAt).fromNow()}</span>
					</div>
				</div>)
		})
	}

	const renderPendingRequests = () => {
		return pendingRequests.map((request: ReceivedContactRequest, index: number) =>
			<div className={`${styles.card} ${styles.pendingRequest}`} key={`pending${index}`}>
				<div className={styles.imageWrapper} onClick={!request.isDeleted ? navigateTo.bind(null, `/members-list/${request.userId}`, onClose) : undefined}>
					{request.imageId && !request.isDeleted ?
						<img alt="Profile" src={request.imageId} /> :
						<Icon name="user" width="16px" color="white" />}
				</div>
				<div>
					<span className={styles.clickable} onClick={!request.isDeleted ? navigateTo.bind(null, `/members-list/${request.userId}`, onClose) : undefined}>
						{!request.isDeleted ?
							<>{request.firstName} {request.lastName}</> :
							<FormattedMessage id="userLabels.deletedUser" />
						}
					</span>
					<p>
						{request.requestMessage}
					</p>
				</div>
				<div className={`${styles.status} ${styles.pending}`}> </div>
			</div>
		)
	}

	const renderRejectedRequests = () => {
		return rejectedRequests.map((request: ReceivedContactRequest, index: number) =>
			<div className={`${styles.card} ${styles.rejectedRequest}`} key={`rejected${index}`}>
				<div className={styles.imageWrapper} onClick={!request.isDeleted ? navigateTo.bind(null, `/members-list/${request.userId}`, onClose) : undefined}>
					{request.imageId && !request.isDeleted ?
						<img alt="Profile" src={request.imageId} /> :
						<Icon name="user" width="16px" color="white" />}
				</div>
				<div>
					<span className={styles.clickable} onClick={!request.isDeleted ? navigateTo.bind(null, `/members-list/${request.userId}`, onClose) : undefined}>
						{!request.isDeleted ?
							<>{request.firstName} {request.lastName}</> :
							<FormattedMessage id="userLabels.deletedUser" />
						}
					</span>
					<p>
						{request.requestMessage}
					</p>
				</div>
				<div className={styles.status}>
					<FormattedMessage id="contactStatus.rejectedRequest" />
				</div>
			</div>
		)
	}

	const renderMyRequests = () => {
		return myRequests.map((request: MyContactRequest, index: number) =>
			<div className={`${styles.card} ${styles.rejectedRequest}`} key={`myRequests${index}`}>
				<h1>
					<span><FormattedMessage id="basics.to" />: </span>
					<span className={styles.clickable} onClick={!request.chat.isDeleted ? navigateTo.bind(null, `/members-list/${request.chat.userId}`, onClose) : undefined}> {request.chat.firstName} {request.chat.lastName}</span><br />
					<span className="light">{moment(request.chat.createdAt).format('dddd, HH:mm')}</span>
				</h1>
				<div className={styles.requestMessages}>
					<i><FormattedMessage id="basics.you" />:</i>
					<p>
						{request.chat.requestMessage}
					</p>

					{request.chat.rejectMessage &&
						<div className={styles.rejectionResponse}>
							<div className={styles.imageWrapper} onClick={!request.chat.isDeleted ? navigateTo.bind(null, `/members-list/${request.chat.userId}`, onClose) : undefined}>
								{request.chat.imageId && !request.chat.isDeleted ?
									<img alt="Profile" src={request.chat.imageId} /> :
									<Icon name="user" width="16px" color="white" />}
							</div>
							<div>
								<h2>{!request.chat.isDeleted ?
									<>{request.chat.firstName} {request.chat.lastName}</> :
									<FormattedMessage id="userLabels.deletedUser" />
								}:</h2>
								<p>{request.chat.rejectMessage}</p>
							{request.chat.userSuggested && <div className={styles.suggestedUser}>
								<FormattedMessage id="contact.suggestedUser" />
								<div className={styles.user}>
									<div className={styles.imageWrapper} onClick={!request.userSuggested.isDeleted ? navigateTo.bind(null, `/members-list/${request.userSuggested.userId}`, onClose) : undefined}>
										{request.userSuggested.imageId && !request.userSuggested.isDeleted ?
											<img alt="Profile" src={request.userSuggested.imageId} /> :
											<Icon name="user" width="10px" color="white" />}
									</div>
									<h2>{!request.userSuggested.isDeleted ?
										<>{request.userSuggested.firstName} {request.userSuggested.lastName}</> :
										<FormattedMessage id="userLabels.deletedUser" />}</h2>
								</div>
								</div>}
								<span className="light">{moment(request.chat.rejectedAt).format('dddd, HH:mm')}</span>
							</div>
						</div>
					}
				</div>
			</div>);
	}

	return (
		<div className={styles.dropdownContainer}>
			<div className={`${styles.dropdownWrapper} ${styles.topBorder}`}>

				{!viewSection ? (
					<>
						<div className={styles.tabBarExtraContentMobile}>
							<Button className={styles.btnWithIcon} type="default" size="large" onClick={toggleSection}>
								<Icon name="paper-plane" />
								<FormattedMessage id="contact.myRequests" />
							</Button>
						</div>
						<Tabs
							className={`withPadding ${styles.tabs}`}
							defaultActiveKey="1"
							tabBarExtraContent={tabBarExtraContent}
						>
							<TabPane
								tab={
									<>
										<FormattedMessage id="contact.conversations" />
										<span className={styles.tabDivider}>/</span>
									</>
								}
								key="1"
							>
								<div className={styles.content}>
									{network?.length ? renderNetwork() : <div className={`${styles.card} ${styles.emptyContent}`}><FormattedMessage id="emptyContent.conversations" /></div>}
								</div>
							</TabPane>
							<TabPane
								tab={
									<>
										<FormattedMessage id="contact.requests" />
									</>
								}
								key="2"
							>
								<div className={styles.content}>
									{renderPendingRequests()}
									{renderRejectedRequests()}
									{!pendingRequests?.length && !rejectedRequests?.length && <div className={`${styles.card} ${styles.emptyContent}`}><FormattedMessage id="emptyContent.newRequests" /></div>}
								</div>
							</TabPane>
						</Tabs>
					</>
				) : (
					<Tabs
						className={`withPadding ${styles.tabs}`}
						defaultActiveKey="1"
						tabBarExtraContent={secondTabBarExtraContent}
					>
						<TabPane
							tab={
								<>
									<FormattedMessage id="contact.myRequests" />
								</>
							}
							key="1"
						>
							<div className={styles.content}>
								{myRequests?.length ? renderMyRequests() : <div className={`${styles.card} ${styles.emptyContent}`}><FormattedMessage id="emptyContent.newRequests" /></div>}
							</div>
						</TabPane>
					</Tabs>
				)}
			</div>
		</div>
	);
}
export default ContactDropdown;